import {
  jb_breadcrumbs_item_css_default
} from "./chunk.2WRI5MNR.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  Linkable
} from "./chunk.534YP5ZJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-breadcrumbs-item/jb-breadcrumbs-item.ts
var JbBreadcrumbsItem = class extends Linkable(i) {
  render() {
    return b`
      <span role="listitem">
        <jb-anchor
          aria-current="${this.current ? "page" : A}"
          flyPadding="0"
          ?inactive=${this.inactive || !this.link?.href}
          .link=${this.link}
          >${this.text}
        </jb-anchor>
      </span>
    `;
  }
};
JbBreadcrumbsItem.styles = [reset_css_default, jb_breadcrumbs_item_css_default];
__decorateClass([
  n({ type: Boolean })
], JbBreadcrumbsItem.prototype, "current", 2);
__decorateClass([
  n({ type: Boolean })
], JbBreadcrumbsItem.prototype, "inactive", 2);
__decorateClass([
  n()
], JbBreadcrumbsItem.prototype, "text", 2);
JbBreadcrumbsItem = __decorateClass([
  customElement("jb-breadcrumbs-item")
], JbBreadcrumbsItem);

export {
  JbBreadcrumbsItem
};
